import styled from "styled-components";

export const ModalContent = styled.div` 

    .loading {
        display: flex;
        justify-content: center;
    }
`

